import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  InputBase,
  Button,
  Pagination,
} from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { formatPhoneNumber } from "../utils/formatnumber";
import { formatTimestamp, formatTime, formatTimestampForZone, formatTimestampForZone2, formatTimestampUtc } from "../utils/formattimestamp";
import { Search } from "@mui/icons-material";

const RecentCalls = ({ navigate, calls }) => {
  const today = new Date();
  const pastDate = new Date(today);
  pastDate.setDate(today.getDate() - 30);
  const [sortConfig, setSortConfig] = useState({ key: "callTime", direction: "desc" });
  const [startDate, setStartDate] = useState(pastDate.toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // for Menu position
  const dropdownRef = useRef(null);



  //toNumber
  const [toNumberDropdownOpen, setToNumberDropdownOpen] = useState(false);
  const [toNumberAnchorEl, setToNumberAnchorEl] = useState(null);
  const [searchToNumber, setSearchToNumber] = useState("");
  const [selectedNumbers, setSelectedNumbers] = useState([]);

  const allToNumbers = Array.from(new Set(calls.map((call) => call.toNumber)));;





  // Toggle dropdown
  const toggleDropdown = (event) => {
    setAnchorEl(event.currentTarget); // Set anchor to button for Menu positioning
    setDropdownOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Sort handling
  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
    //setDropdownOpen(false)

  };


  // Handle To Number filter
  const handleSelectAllNumbers = (checked) => {
    setSelectedNumbers(checked ? allToNumbers.filter((number) =>
      number.toLowerCase().includes(searchToNumber.toLowerCase())
    ).slice(0, 20) : []);
  };

  const handleSelectNumber = (number) => {
    setSelectedNumbers((prev) =>
      prev.includes(number) ? prev.filter((n) => n !== number) : [...prev, number]
    );
  };


  // Toggle dropdown for To Number filter
  const toggleToNumberDropdown = (event) => {
    setToNumberAnchorEl(event.currentTarget);
    setToNumberDropdownOpen((prev) => !prev);
  };



  //callNumber
  const [callNumberDropdownOpen, setCallNumberDropdownOpen] = useState(false);
  const [callNumberAnchorEl, setCallNumberAnchorEl] = useState(null);
  const [searchCallNumber, setSearchCallNumber] = useState("");
  const [selectedCallNumbers, setSelectedCallNumbers] = useState([]);

  const allCallNumbers = Array.from(new Set(calls.map((call) => call.callerNumber)));;


  // Handle To Number filter
  const handleSelectAllCallNumbers = (checked) => {
    setSelectedCallNumbers(checked ? allCallNumbers.filter((number) =>
      number.toLowerCase().includes(searchCallNumber.toLowerCase())
    ).slice(0, 20) : []);
  };

  const handleSelectCallNumber = (number) => {
    //console.log({number})
    setSelectedCallNumbers((prev) =>
      prev.includes(number) ? prev.filter((n) => n !== number) : [...prev, number]
    );
  };


  // Toggle dropdown for To Number filter
  const toggleCallNumberDropdown = (event) => {
    setCallNumberAnchorEl(event.currentTarget);
    setCallNumberDropdownOpen((prev) => !prev);
  };




  //callNumber
  const [actionDropdownOpen, setActionDropdownOpen] = useState(false);
  const [actionAnchorEl, setActionAnchorEl] = useState(null);
  const [searchAction, setSearchAction] = useState("");
  const [selectedActions, setSelectedActions] = useState([]);

  const allActions = Array.from(new Set(calls.map((call) => call.action))).slice(0, 20);;


  // Handle To Number filter
  const handleSelectAllActions = (checked) => {
    setSelectedActions(checked ? allActions : []);
  };

  const handleSelectAction = (number) => {
    setSelectedActions((prev) =>
      prev.includes(number) ? prev.filter((n) => n !== number) : [...prev, number]
    );
  };


  // Toggle dropdown for To Number filter
  const toggleActionDropdown = (event) => {
    setActionAnchorEl(event.currentTarget);
    setActionDropdownOpen((prev) => !prev);
  };


  //callNumber
  const [actionDetailDropdownOpen, setActionDetailDropdownOpen] = useState(false);
  const [actionDetailAnchorEl, setActionDetailAnchorEl] = useState(null);
  const [searchActionDetail, setSearchActionDetail] = useState("");
  const [selectedActionDetails, setSelectedActionDetails] = useState([]);

  const allActionDetails = Array.from(new Set(calls.map((call) => call.actionDetails))).slice(0, 20);;


  // Handle To Number filter
  const handleSelectAllActionDetails = (checked) => {
    setSelectedActionDetails(checked ? allActionDetails : []);
  };

  const handleSelectActionDetail = (number) => {
    setSelectedActionDetails((prev) =>
      prev.includes(number) ? prev.filter((n) => n !== number) : [...prev, number]
    );
  };


  // Toggle dropdown for To Number filter
  const toggleActionDetailDropdown = (event) => {
    setActionDetailAnchorEl(event.currentTarget);
    setActionDetailDropdownOpen((prev) => !prev);
  };



  //callNumber
  const [voicemailDropdownOpen, setVoicemailDropdownOpen] = useState(false);
  const [voicemailAnchorEl, setVoicemailAnchorEl] = useState(null);
  const [searchVoicemail, setSearchVoicemail] = useState("");
  const [selectedVoicemails, setSelectedVoicemails] = useState([]);

  const allVoicemails = Array.from(new Set(calls.map((call) => call.voicemail))).slice(0, 20);;


  // Handle To Number filter
  const handleSelectAllVoicemails = (checked) => {
    setSelectedVoicemails(checked ? allVoicemails : []);
  };

  const handleSelectVoicemail = (number) => {
    setSelectedVoicemails((prev) =>
      prev.includes(number) ? prev.filter((n) => n !== number) : [...prev, number]
    );
  };


  // Toggle dropdown for To Number filter
  const toggleVoicemailDropdown = (event) => {
    setVoicemailAnchorEl(event.currentTarget);
    setVoicemailDropdownOpen((prev) => !prev);
  };

  const [currentPage, setCurrentPage] = useState(1);


  const filteredCalls = calls.filter((call) => {
    console.log({ startDate })

    let callDate;

    // Normalize callTime based on its length (seconds or milliseconds)
    if (call.callTime.length === 10) {
      // If callTime is in seconds, multiply by 1000 to convert to milliseconds
      callDate = new Date(Number(call.callTime) * 1000);
      ////console.log({callDate, time: call.callTime})
    } else {
      // If callTime is in milliseconds
      callDate = new Date(Number(call.callTime));
      // //console.log({callDate, time: call.callTime})
    }

    // Set the call date to the start of the day (midnight)
    callDate.setHours(0, 0, 0, 0);

    // Normalize the start and end dates to the start of the day for startDate and end of the day for endDate
    const start = startDate
      ? new Date(`${startDate}`) 
      : null; // Midnight of startDate
    console.log({ start })
    const end = endDate ? new Date(endDate).setHours(23, 59, 59, 999) : null; // End of the day for endDate

    //console.log({end})

    ////console.log({ start, callDate, end });

    // Return filtered calls based on the selected conditions
    return (
      (!start || callDate >= start) &&
      (!end || callDate <= end) &&
      (selectedNumbers.length === 0 || selectedNumbers.includes(call.toNumber)) &&
      (selectedCallNumbers.length === 0 || selectedCallNumbers.includes(call.callerNumber)) &&
      (selectedActions.length === 0 || selectedActions.includes(call.action)) &&
      (selectedActionDetails.length === 0 || selectedActionDetails.includes(call.actionDetails)) &&
      (selectedVoicemails.length === 0 || selectedVoicemails.includes(call.voicemail))
    );
  });


  const sortedRows = React.useMemo(() => {


    return [...filteredCalls].sort((a, b) => {
      const isAscending = sortConfig.direction === "asc";
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (typeof aValue === "number" && typeof bValue === "number") {
        return isAscending ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return isAscending
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      // Handle cases where types are mixed (if applicable)
      return 0;
    });
  }, [filteredCalls, sortConfig]);


  // Pagination Logic
  const callsPerPage = 12; // Number of calls per page
  const indexOfLastCall = currentPage * callsPerPage;
  const indexOfFirstCall = indexOfLastCall - callsPerPage;
  const currentCalls = sortedRows.slice(indexOfFirstCall, indexOfLastCall);

  // Calculate total pages based on the current calls length
  let totalPages = Math.ceil(sortedRows.length / callsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    //setDropdownOpen(false);
    // setToNumberDropdownOpen(false)
    //setCallNumberDropdownOpen(false)
    //setActionDropdownOpen(false)
    // setActionDetailDropdownOpen(false)
    //setVoicemailDropdownOpen(false)
    setCurrentPage(1)
  }, [sortConfig, startDate, endDate, selectedNumbers, selectedCallNumbers, selectedActions, selectedActionDetails, selectedVoicemails]);

  const resetFilters = () => {
    setStartDate(pastDate.toISOString().split('T')[0]);
    setEndDate(new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]);
    setSelectedCallNumbers([]);
    setSelectedNumbers([]);
    setSelectedActions([]);
    setSelectedActionDetails([]);
    setSelectedVoicemails([]);

    setSortConfig({ key: "callTime", direction: "desc" });

    // Close all dropdowns
    setDropdownOpen(false);
    setToNumberDropdownOpen(false);
    setCallNumberDropdownOpen(false);
    setActionDropdownOpen(false);
    setActionDetailDropdownOpen(false);
    setVoicemailDropdownOpen(false);

    // Reset pagination
    setCurrentPage(1);
  };

  const isFilteredOrSorted = () => {
    return (
      startDate !== pastDate.toISOString().split('T')[0] ||
      endDate !== new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0] ||
      sortConfig.key !== "callTime" ||
      sortConfig.direction !== "desc" ||
      selectedCallNumbers.length >= 1 || selectedNumbers.length >= 1
      || selectedActions.length >= 1
      || selectedActionDetails.length >= 1
      || selectedVoicemails.length >= 1
    );
  };
  function timeDifferenceFromToday(dateString) {
    // Convert the input date string to a Date object
    const givenDate = new Date(dateString);

    // Get today's date
    const today = new Date();

    // Calculate the difference in milliseconds
    const timeDifference = today - givenDate;

    // Convert the time difference to days, hours, and minutes
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    return days;
  }


  useEffect(() => {
    // Ensure the current page stays within valid bounds
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  return (
    <div>
      {/* Table */}
      {/* Improved Pagination Controls using Material UI */}
      <div className="flex justify-center mt-4 absolute top-0 right-2">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          shape="rounded"
          size="small"
          siblingCount={1}
          boundaryCount={1}
        />
      </div>
      <TableContainer className="w-full overflow-x-auto lg:overflow-hidden">
        <div
          className="cursor-pointer text-[16px] font-semibold text-[#030229] px-4 mb-3 pt-3"
        >
          Recent Calls
        </div>
        <div className="flex space-x-3 items-center px-4">
          {isFilteredOrSorted() && (
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#605BFF",
                color: "white",
                py: "1px",
                px: "10px",
                borderRadius: "7px",
                fontSize: { lg: "12px", xs: "12px" },
              }}
              onClick={() => {
                resetFilters();
              }}
            >
              Reset Filters & Sort
            </Button>
          )}


          {startDate && (
            <div className="text-[13px]">-Showing calls from 

          {/* {" "}  <span className="text-red-900" >{startDate} </span> {' '} */} {" "}
            
            {`${formatTimestampUtc(startDate)}`}, {timeDifferenceFromToday(startDate)} days ago.</div>
          )}
        </div>
        <Table style={{ minWidth: "1100px" }}>
          <TableHead className="bg-white">
            <TableRow>
              {/* Dropdown in Call Time */}
              <TableCell className="relative font-semibold cursor-pointer">
                <button
                  onClick={toggleDropdown}
                  className="flex items-center gap-1"
                  ref={dropdownRef}
                >
                  Call Time
                  {dropdownOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </button>
                <Menu
                  anchorEl={anchorEl}
                  open={dropdownOpen}
                  onClose={() => setDropdownOpen(false)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}

                >
                  <div className="px-2">
                    <MenuItem onClick={() => handleSort('callTime', "asc")}     >
                      <div className="text-[14px] text-center w-full ">Sort Earliest to Recent</div>
                    </MenuItem>
                    <MenuItem onClick={() => handleSort('callTime', "desc")}>
                      <div className="text-[14px] text-center w-full">Sort Recent to Earliest</div>

                    </MenuItem>
                    <div className="mb-2 flex items-center space-x-3 mt-1 w-full">
                      <label className="block text-sm mb-1 w-full">Start Date</label>
                      <input
                        type="date"
                        style={{ outline: "none", backgroundColor: '#FAFAFB', border: '1px solid #FAFAFB', borderRadius: '10px' }}
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="w-full border rounded px-2 py-1"
                        max={(new Date()).toISOString().split('T')[0]}
                      />
                    </div>
                    <div className="flex items-center space-x-2" >
                      <label className="block text-sm mb-1 w-full">End Date</label>
                      <input
                        type="date"
                        style={{ outline: "none", backgroundColor: '#FAFAFB', border: '1px solid #FAFAFB', borderRadius: '10px' }}
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="w-full border rounded px-2 py-1"
                        max={(new Date()).toISOString().split('T')[0]}
                      />
                    </div>
                  </div>
                </Menu>
              </TableCell>
              <TableCell className="font-semibold">
                <button
                  onClick={toggleToNumberDropdown}
                  className="flex items-center gap-1"
                >
                  To Number
                  {toNumberDropdownOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </button>
                <Menu
                  anchorEl={toNumberAnchorEl}
                  open={toNumberDropdownOpen}
                  onClose={() => setToNumberDropdownOpen(false)}
                >
                  <MenuItem onClick={() => handleSort('toNumber', "asc")}     >
                    <div className="text-[14px] text-left w-full ">Sort A-Z</div>
                  </MenuItem>
                  <MenuItem onClick={() => handleSort('toNumber', "desc")}>
                    <div className="text-[14px] text-left w-full">Sort Z-A</div>
                  </MenuItem>
                  <div className="p-2 mt-1">
                    <InputBase
                      endAdornment={
                        <Search sx={{ fontSize: '20px', color: '#C9C8D1' }} />
                      }
                      type="text"
                      placeholder="Search"
                      value={searchToNumber}
                      onChange={(e) => setSearchToNumber(e.target.value)}
                      className="w-full border rounded px-2 py-1 mb-2 outline-none bg-[rgba(250,250,251,0.3)]"
                    />
                    <MenuItem onClick={() => handleSelectAllNumbers(!(selectedNumbers.length === allToNumbers.slice(0, 20).length))}>
                      <div className="text-[14px] flex items-center">
                        <Checkbox size={'small'}
                          checked={selectedNumbers.length === allToNumbers
                            .filter((number) =>
                              number.toLowerCase().includes(searchToNumber.toLowerCase())
                            ).slice(0, 20).length}
                        // onChange={(e) => handleSelectAllNumbers(e.target.checked)}
                        />
                        Select All</div>
                    </MenuItem>
                    {allToNumbers
                      .filter((number) =>
                        number.toLowerCase().includes(searchToNumber.toLowerCase())
                      )
                      .slice(0, 20)
                      .map((number, index) => (
                        <MenuItem key={index} onClick={() => handleSelectNumber(number)}>
                          <div className="text-[14px] flex items-center">
                            <Checkbox sx={{ fontSize: '' }} size="small"
                              checked={selectedNumbers.includes(number)}
                            //onChange={() => handleSelectNumber(number)}
                            />
                            {number}
                          </div>
                        </MenuItem>
                      ))}
                  </div>
                </Menu>
              </TableCell>
              <TableCell className="font-semibold">
                <button
                  onClick={toggleCallNumberDropdown}
                  className="flex items-center gap-1"
                >
                  Caller Number
                  {toNumberDropdownOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </button>
                <Menu
                  anchorEl={callNumberAnchorEl}
                  open={callNumberDropdownOpen}
                  onClose={() => setCallNumberDropdownOpen(false)}
                >
                  <MenuItem onClick={() => handleSort('callerNumber', "asc")}     >
                    <div className="text-[14px] text-left w-full ">Sort A-Z</div>
                  </MenuItem>
                  <MenuItem onClick={() => handleSort('callerNumber', "desc")}>
                    <div className="text-[14px] text-left w-full">Sort Z-A</div>
                  </MenuItem>
                  <div className="p-2 mt-1">
                    <InputBase
                      endAdornment={
                        <Search sx={{ fontSize: '20px', color: '#C9C8D1' }} />
                      }
                      type="text"
                      placeholder="Search"
                      value={searchCallNumber}
                      onChange={(e) => setSearchCallNumber(e.target.value)}
                      className="w-full border rounded px-2 py-1 mb-2 outline-none bg-[rgba(250,250,251,0.3)]"
                    />
                    <MenuItem onClick={() => handleSelectAllCallNumbers(!(selectedCallNumbers.length === allCallNumbers.slice(0, 20).length))}>
                      <div className="text-[14px] flex items-center">
                        <Checkbox size={'small'}
                          checked={selectedCallNumbers.length === allCallNumbers.filter((number) =>
                            number.toLowerCase().includes(searchCallNumber.toLowerCase())
                          ).slice(0, 20).length}
                        // onChange={(e) => handleSelectAllCallNumbers(e.target.checked)}
                        />
                        Select All</div>
                    </MenuItem>
                    {allCallNumbers

                      .filter((number) =>
                        number.toLowerCase().includes(searchCallNumber.toLowerCase())
                      )
                      .slice(0, 20)
                      .map((number, index) => (
                        <MenuItem key={index} onClick={() => handleSelectCallNumber(number)}>
                          <div className="text-[14px] flex items-center">
                            <Checkbox sx={{ fontSize: '' }} size="small"
                              checked={selectedCallNumbers.includes(number)}
                            //onChange={() => handleSelectCallNumber(number)}
                            />
                            {number}
                          </div>
                        </MenuItem>
                      ))}
                  </div>
                </Menu>
              </TableCell>
              <TableCell className="font-semibold">
                <button
                  onClick={toggleActionDropdown}
                  className="flex items-center gap-1"
                >
                  Action
                  {actionDropdownOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </button>
                <Menu
                  anchorEl={actionAnchorEl}
                  open={actionDropdownOpen}
                  onClose={() => setActionDropdownOpen(false)}
                >
                  <MenuItem onClick={() => handleSort('action', "asc")}     >
                    <div className="text-[14px] text-left w-full ">Sort A-Z</div>
                  </MenuItem>
                  <MenuItem onClick={() => handleSort('action', "desc")}>
                    <div className="text-[14px] text-left w-full">Sort Z-A</div>
                  </MenuItem>
                  <div className="p-2 mt-1">
                    <InputBase
                      endAdornment={
                        <Search sx={{ fontSize: '20px', color: '#C9C8D1' }} />
                      }
                      type="text"
                      placeholder="Search"
                      value={searchAction}
                      onChange={(e) => setSearchAction(e.target.value)}
                      className="w-full border rounded px-2 py-1 mb-2 outline-none bg-[rgba(250,250,251,0.3)]"
                    />
                    <MenuItem onClick={() => handleSelectAllActions(!(selectedActions.length === allActions.length))}>
                      <div className="text-[14px] flex items-center">
                        <Checkbox size={'small'}
                          checked={selectedActions.length === allActions.length}
                        //onChange={(e) => handleSelectAllActions(e.target.checked)}
                        />
                        Select All</div>
                    </MenuItem>
                    {allActions
                      .filter((number) =>
                        number.toLowerCase().includes(searchAction.toLowerCase())
                      )
                      .map((data, index) => (
                        <MenuItem key={index} onClick={() => handleSelectAction(data)}>
                          <div className="text-[14px] flex items-center">
                            <Checkbox sx={{ fontSize: '' }} size="small"
                              checked={selectedActions.includes(data)}
                            //onChange={() => handleSelectAction(data)}
                            />
                            {data}
                          </div>
                        </MenuItem>
                      ))}
                  </div>
                </Menu>
              </TableCell>
              <TableCell className="font-semibold">
                <button
                  onClick={toggleActionDetailDropdown}
                  className="flex items-center gap-1"
                >
                  Action Details
                  {actionDetailDropdownOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </button>
                <Menu
                  anchorEl={actionDetailAnchorEl}
                  open={actionDetailDropdownOpen}
                  onClose={() => setActionDetailDropdownOpen(false)}
                >
                  <MenuItem onClick={() => handleSort('actionDetail', "asc")}     >
                    <div className="text-[14px] text-left w-full ">Sort A-Z</div>
                  </MenuItem>
                  <MenuItem onClick={() => handleSort('actionDetail', "desc")}>
                    <div className="text-[14px] text-left w-full">Sort Z-A</div>
                  </MenuItem>
                  <div className="p-2 mt-1">
                    <InputBase
                      endAdornment={
                        <Search sx={{ fontSize: '20px', color: '#C9C8D1' }} />
                      }
                      type="text"
                      placeholder="Search"
                      value={searchActionDetail}
                      onChange={(e) => setSearchActionDetail(e.target.value)}
                      className="w-full border rounded px-2 py-1 mb-2 outline-none bg-[rgba(250,250,251,0.3)]"
                    />
                    <MenuItem onClick={() => handleSelectAllActionDetails(!(selectedActionDetails.length === allActionDetails.length))}>
                      <div className="text-[14px] flex items-center">
                        <Checkbox size={'small'}
                          checked={selectedActionDetails.length === allActionDetails.length}
                        //onChange={(e) => handleSelectAllActionDetails(e.target.checked)}
                        />
                        Select All</div>
                    </MenuItem>
                    {allActionDetails
                      .filter((number) =>
                        number.toLowerCase().includes(searchActionDetail.toLowerCase())
                      )
                      .map((data, index) => (
                        <MenuItem key={index} onClick={() => handleSelectActionDetail(data)}>
                          <div className="text-[14px] flex items-center">
                            <Checkbox sx={{ fontSize: '' }} size="small"
                              checked={selectedActionDetails.includes(data)}
                            //onChange={() => handleSelectActionDetail(data)}
                            />
                            {data}
                          </div>
                        </MenuItem>
                      ))}
                  </div>
                </Menu>
              </TableCell>
              <TableCell className="font-semibold">
                <button
                  onClick={toggleVoicemailDropdown}
                  className="flex items-center gap-1"
                >
                  Voicemail
                  {voicemailDropdownOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </button>
                <Menu
                  anchorEl={voicemailAnchorEl}
                  open={voicemailDropdownOpen}
                  onClose={() => setVoicemailDropdownOpen(false)}
                >
                  <MenuItem onClick={() => handleSort('voicemail', "asc")}     >
                    <div className="text-[14px] text-left w-full ">Sort A-Z</div>
                  </MenuItem>
                  <MenuItem onClick={() => handleSort('voicemail', "desc")}>
                    <div className="text-[14px] text-left w-full">Sort Z-A</div>
                  </MenuItem>
                  <div className="p-2 mt-1">
                    <InputBase
                      endAdornment={
                        <Search sx={{ fontSize: '20px', color: '#C9C8D1' }} />
                      }
                      type="text"
                      placeholder="Search"
                      value={searchVoicemail}
                      onChange={(e) => setSearchVoicemail(e.target.value)}
                      className="w-full border rounded px-2 py-1 mb-2 outline-none bg-[rgba(250,250,251,0.3)]"
                    />
                    <MenuItem onClick={() => handleSelectAllVoicemails(!(selectedVoicemails.length === allVoicemails.length))}>
                      <div className="text-[14px] flex items-center">
                        <Checkbox size={'small'}
                          checked={selectedVoicemails.length === allVoicemails.length}
                        //onChange={(e) => handleSelectAllVoicemails(e.target.checked)}
                        />
                        Select All</div>
                    </MenuItem>
                    {allVoicemails
                      .filter((number) =>
                        number.toLowerCase().includes(searchVoicemail.toLowerCase())
                      )
                      .map((data, index) => (
                        <MenuItem key={index} onClick={() => handleSelectVoicemail(data)}>
                          <div className="text-[14px] flex items-center">
                            <Checkbox sx={{ fontSize: '' }} size="small"
                              checked={selectedVoicemails.includes(data)}
                            //onChange={() => handleSelectVoicemail(data)}
                            />
                            {data}
                          </div>
                        </MenuItem>
                      ))}
                  </div>
                </Menu>
              </TableCell>
              <TableCell className="font-semibold">More Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentCalls.map((row, index) => (
              <TableRow
                key={index}
                className={index % 2 === 0 ? "bg-white" : "bg-[#FAFAFB]"}
              >
                <TableCell>{`${formatTimestampForZone(row?.callTime)}`}  </TableCell>
                <TableCell>{formatPhoneNumber(row.toNumber)}</TableCell>
                <TableCell>{formatPhoneNumber(row.callerNumber)}</TableCell>
                <TableCell>{row.action}</TableCell>
                <TableCell>{row.actionDetails}</TableCell>
                <TableCell>{row.voicemail}</TableCell>
                <TableCell>
                  <IconButton onClick={() => navigate(row.link)}>
                    <ChevronRightIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default RecentCalls;
